'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const date = require('@zapier/date');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_forms_DateRangePicker_utils = require('./utils.cjs.js');

const Styles = {
  root: react.css`
    display: block;
    overflow: hidden;
    white-space: nowrap;
  `,
  wrapper: react.css`
    display: flex;
    max-width: 100%;
    overflow: hidden;
  `
};
function getRangeText(value) {
  const isSameDate = components_forms_DateRangePicker_utils.isSameDay(value.from, value.to);
  const from = value.from ? (
    // We have to ignore profile timezone here and just stick to the browser
    // since there could be a huge mismatch which would result in the days showing
    // different values 😭
    react.jsx(date.DateTime, { date: value.from, format: "MM/DD/YY", ignoreProfileTimezone: true })
  ) : null;
  const to = !isSameDate && value.to ? react.jsx(date.DateTime, { date: value.to, format: "MM/DD/YY", ignoreProfileTimezone: true }) : null;
  return react.jsx(
    React.Fragment,
    null,
    from,
    Boolean(from) && Boolean(to) && " – ",
    to
  );
}
const DateRangePickerValue = ({ options, value }) => {
  const selectedOption = options.find((option) => components_forms_DateRangePicker_utils.isSameDay(option.value.from, value.from) && components_forms_DateRangePicker_utils.isSameDay(option.value.to, value.to));
  const rangeText = getRangeText(value);
  return react.jsx(
    "div",
    { css: Styles.wrapper, "data-zds": true },
    react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: selectedOption ? rangeText : null }, ({ childProps }) => react.jsx("span", { "aria-describedby": childProps["aria-describedby"], css: Styles.root, "data-zds": true }, selectedOption ? selectedOption.text : rangeText))
  );
};

exports.DateRangePickerValue = DateRangePickerValue;
//# sourceMappingURL=DateRangePickerValue.cjs.js.map
